import { ExperimentState, OriginalExperimentState } from 'modules/experiments/takeover/types';
import { CampaignConversion } from 'modules/experiments/types';
import { mutateEditExperimentVariantState } from 'modules/experiments/utils';
import { createSelector } from 'reselect';

const getTakeoverPage = (state: Record<string, any>) =>
  state.experiments.takeover.experiment as ExperimentState;
export const getTakeoverExperimentLoading = (state: Record<string, any>) =>
  getTakeoverPage(state).loading;
const getTakeoverExperimentHasError = (state: Record<string, any>) => getTakeoverPage(state).error;
export const getTakeoverExperimentData = (state: Record<string, any>) =>
  getTakeoverPage(state).data;
const getTakeoverCampaign = (state: Record<string, any>) =>
  getTakeoverExperimentData(state).campaign;

export const getTakeoverExperimentId = (state: Record<string, any>) =>
  getTakeoverExperimentData(state).id;

export const getTakeoverExperimentType = (state: Record<string, any>) =>
  getTakeoverExperimentData(state).type;

export const getTakeoverExperimentState = (state: Record<string, any>) =>
  getTakeoverExperimentData(state).state;

export const getTakeoverExperimentName = (state: Record<string, any>) =>
  getTakeoverExperimentData(state).name;

export const getTakeoverCampaignId = (state: Record<string, any>) => getTakeoverCampaign(state).id;

export const getTakeoverCampaignLists = (state: Record<string, any>) =>
  getTakeoverCampaign(state).lists;

export const getTakeoverCampaignMessageMedium = (state: Record<string, any>) =>
  getTakeoverCampaign(state).messageMedium;

export const getTakeoverCampaignConversions = createSelector(
  [getTakeoverExperimentData],
  (experiment: OriginalExperimentState): CampaignConversion[] =>
    experiment.campaign.conversions.map(({ id, events }) => ({ id, name: events?.[0]?.name })),
);

export const getTakeoverCampaignType = (state: Record<string, any>) =>
  getTakeoverCampaign(state).type;

export const getTakeoverCampaignState = (state: Record<string, any>) =>
  getTakeoverCampaign(state).state;

export const getTakeoverExperimentUIState = createSelector(
  [getTakeoverExperimentLoading, getTakeoverExperimentHasError],
  (loadingState: boolean, errorState: boolean) => ({ loadingState, errorState }),
);

export const getTakeoverVariantList = createSelector(
  [getTakeoverExperimentData],
  (experiment: OriginalExperimentState) => mutateEditExperimentVariantState(experiment.variations),
);
